import { initHttpClient } from '@luminovo/http-client';
import { createRoot } from 'react-dom/client';

import App from '@/app/App';
import { runCookieConsent } from '@/shared/utils/services';
import { installStaleAppDetection } from '@/shared/utils/staleApp';

// Same origin as the backend everywhere (vite proxies it in dev); GATEWAY_HOST is empty when same-origin.
initHttpClient({
    backendHost: window.origin,
    hostName: window.location.host,
    gatewayBase: import.meta.env.GATEWAY_HOST + '/api',
});

runCookieConsent();

// Before the first render, so a chunk that fails while the app is still booting is caught too.
installStaleAppDetection();

const container = document.getElementById('root') as HTMLElement;

const root = createRoot(container);
root.render(<App />);
